import React from "react";

const UnderApproved = () => {
  return (
    <div className="sales-tool-root">
      <h1>UnderApproved comp</h1>
    </div>
  );
};

export default UnderApproved;